/* DDD footer harbour: a little sea you can play with.
   - The ship (cut from Pete's own logo file, assets/dd-ship.png) bobs and tilts on a spring-simulated sea.
   - Move the mouse / drag a finger to steer it; left alone it potters about.
   - Click or tap the water to splash and send waves out; tap the ship to make it hop.
   Runs only while the footer is on screen; static under prefers-reduced-motion. */
(function () {
  "use strict";
  var host = document.querySelector("[data-dd-harbour]"); if (!host) return;
  var cv = host.querySelector("canvas"); if (!cv || !cv.getContext) return;
  var ctx = cv.getContext("2d");
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hint = host.querySelector("[data-dd-harbour-hint]");
  if (hint && window.matchMedia("(pointer: coarse)").matches && hint.lastChild) hint.lastChild.nodeValue = "Drag to steer the ship, tap the water to make waves";

  var W = 0, H = 0, DPR = 1, SP = 7, N = 0, h = [], v = [], rest = 0, BW = 110;
  var boat = { x: 0, vx: 0, y: 0, a: 0, tx: 0, dir: 1, hop: 0, hv: 0, next: 0 };
  var ptr = { in: false, x: 0, y: 0, lx: 0, ly: 0, t: -1e9 };
  var drops = [], puffs = [], stars = [], now = 0, lastPuff = 0, played = false;
  var shipImg = new Image(), shipReady = false, SR = 129 / 158;
  shipImg.onload = function () { shipReady = true; SR = shipImg.naturalHeight / shipImg.naturalWidth; };
  if (host.getAttribute("data-ship")) shipImg.src = host.getAttribute("data-ship");

  function size() {
    var r = host.getBoundingClientRect();
    DPR = Math.min(2, window.devicePixelRatio || 1);
    W = Math.max(1, r.width); H = Math.max(1, r.height);
    cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    var n = Math.ceil(W / SP) + 3;
    if (n !== N) { N = n; h = []; v = []; for (var i = 0; i < N; i++) { h.push(0); v.push(0); } }
    rest = H * 0.6;
    BW = Math.max(86, Math.min(150, W * 0.1));
    if (!boat.x) { boat.x = W * 0.32; boat.tx = W * 0.6; boat.y = rest; }
    boat.x = Math.min(boat.x, W - BW);
    stars = [];
    for (var s = 0; s < Math.round(W / 34); s++) stars.push({ x: Math.random() * W, y: Math.random() * rest * 0.7, r: Math.random() * 1.1 + 0.3, p: Math.random() * 6.3 });
  }

  // water height (screen y) at x: simulated springs + two gentle swells
  function surf(x, t) {
    var i = x / SP, i0 = Math.max(0, Math.min(N - 2, Math.floor(i))), f = Math.max(0, Math.min(1, i - i0));
    var sim = h[i0] * (1 - f) + h[i0 + 1] * f;
    return rest + sim + Math.sin(x * 0.011 + t * 0.0011) * 5 + Math.sin(x * 0.029 - t * 0.0016) * 2.5;
  }
  function push(x, power, spray) {
    var i = Math.round(x / SP);
    for (var k = -3; k <= 3; k++) { var j = i + k; if (j >= 0 && j < N) v[j] += power * (1 - Math.abs(k) / 4); }
    if (!spray) return;
    var n = Math.min(30, Math.round(Math.abs(power) * 1.3)), y = surf(x, now);
    for (var d = 0; d < n; d++) drops.push({ x: x + (Math.random() - 0.5) * 18, y: y - 2, vx: (Math.random() - 0.5) * 3.4, vy: -(Math.random() * 3.6 + 2.2) * Math.min(1.6, Math.abs(power) / 16), r: Math.random() * 1.8 + 1 });
  }
  function water() {
    for (var i = 0; i < N; i++) { v[i] += -0.028 * h[i] - 0.022 * v[i]; h[i] += v[i]; }
    var l = [], r = [];
    for (var pass = 0; pass < 3; pass++) {
      for (var a = 0; a < N; a++) {
        l[a] = a > 0 ? 0.24 * (h[a] - h[a - 1]) : 0; if (a > 0) v[a - 1] += l[a];
        r[a] = a < N - 1 ? 0.24 * (h[a] - h[a + 1]) : 0; if (a < N - 1) v[a + 1] += r[a];
      }
      for (var b = 0; b < N; b++) { if (b > 0) h[b - 1] += l[b]; if (b < N - 1) h[b + 1] += r[b]; }
    }
  }

  function sail(t) {
    if (ptr.in && t - ptr.t < 3500) boat.tx = Math.max(BW * 0.6, Math.min(W - BW * 0.6, ptr.x));
    else if (t > boat.next) { boat.tx = W * (0.12 + Math.random() * 0.76); boat.next = t + 5000 + Math.random() * 6000; }
    var dx = boat.tx - boat.x, want = Math.max(-2.8, Math.min(2.8, dx * 0.025));
    boat.vx += (want - boat.vx) * 0.05; boat.x += boat.vx;
    if (Math.abs(boat.vx) > 0.25) boat.dir = boat.vx > 0 ? 1 : -1;
    if (Math.abs(boat.vx) > 0.7 && Math.random() < 0.35) push(boat.x - boat.dir * BW * 0.5, Math.abs(boat.vx) * 0.55, false);
    var yl = surf(boat.x - BW * 0.32, t), yr = surf(boat.x + BW * 0.32, t);
    boat.y += ((yl + yr) / 2 - boat.y) * 0.3;
    boat.a += (Math.atan2(yr - yl, BW * 0.64) - boat.a) * 0.18;
    if (boat.hop < 0 || boat.hv) {
      boat.hv += 0.42; boat.hop += boat.hv;
      if (boat.hop >= 0) { boat.hop = 0; boat.hv = 0; push(boat.x, 20, true); }
    }
    if (t - lastPuff > 950) {
      lastPuff = t;
      var sh = BW * 1.05 * SR, fx = boat.x + Math.sin(boat.a) * sh * 0.78, fy = boat.y + boat.hop - sh * 0.8;
      puffs.push({ x: fx, y: fy, r: 3 + Math.random() * 2, life: 1, vx: -boat.vx * 0.3 + (Math.random() - 0.5) * 0.2 });
    }
  }

  function particles() {
    for (var i = drops.length - 1; i >= 0; i--) {
      var d = drops[i]; d.vy += 0.17; d.x += d.vx; d.y += d.vy;
      if (d.vy > 0 && d.y > surf(d.x, now)) drops.splice(i, 1);
    }
    for (var j = puffs.length - 1; j >= 0; j--) {
      var p = puffs[j]; p.y -= 0.5; p.x += p.vx; p.r += 0.12; p.life -= 0.014;
      if (p.life <= 0) puffs.splice(j, 1);
    }
  }

  // The ship: Pete's logo ship as an image, waterline about a fifth of the way up the hull.
  // (The vector below is only a fallback while the image loads.)
  function ship() {
    if (shipReady) {
      var sw = BW * 1.05, sh = sw * SR;
      ctx.save();
      ctx.translate(boat.x, boat.y + boat.hop);
      ctx.rotate(boat.a);
      ctx.scale(boat.dir, 1);
      ctx.drawImage(shipImg, -sw / 2, -sh * 0.8, sw, sh);
      ctx.restore();
      return;
    }
    var s = BW / 39;
    ctx.save();
    ctx.translate(boat.x, boat.y + boat.hop);
    ctx.rotate(boat.a);
    ctx.scale(s * boat.dir, s);
    ctx.translate(-24, -27);
    ctx.fillStyle = "#5a9fd4";
    ctx.fillRect(21, 4, 6, 4.4);
    ctx.fillRect(17, 8.8, 14, 4.8);
    ctx.fillRect(12.5, 14, 23, 4.8);
    ctx.beginPath(); ctx.moveTo(4.5, 20.6); ctx.quadraticCurveTo(24, 27.6, 43.5, 20.6); ctx.lineTo(37.4, 41.2); ctx.quadraticCurveTo(24, 44.2, 10.6, 41.2); ctx.closePath();
    var g = ctx.createLinearGradient(0, 20, 0, 44); g.addColorStop(0, "#5aa3da"); g.addColorStop(1, "#3a7fb8");
    ctx.fillStyle = g; ctx.fill();
    ctx.strokeStyle = "rgba(255,255,255,0.55)"; ctx.lineWidth = 1.2;
    ctx.beginPath(); ctx.moveTo(8, 25.4); ctx.quadraticCurveTo(24, 31, 40, 25.4); ctx.stroke();
    ctx.fillStyle = "rgba(255,255,255,0.85)";
    for (var k = 0; k < 4; k++) { ctx.beginPath(); ctx.arc(15 + k * 6, 32, 1.1, 0, 6.29); ctx.fill(); }
    ctx.restore();
  }

  function seaPath(t, lift, amp, phase) {
    ctx.beginPath(); ctx.moveTo(0, H);
    for (var x = 0; x <= W + SP; x += SP) {
      var y = lift ? rest - lift + Math.sin(x * 0.009 + t * 0.0009 + phase) * amp + Math.sin(x * 0.02 - t * 0.0012) * amp * 0.5 : surf(x, t);
      ctx.lineTo(x, y);
    }
    ctx.lineTo(W, H); ctx.closePath();
  }

  function draw(t) {
    ctx.clearRect(0, 0, W, H);
    // stars
    for (var i = 0; i < stars.length; i++) {
      var st = stars[i]; ctx.globalAlpha = 0.25 + 0.3 * (0.5 + 0.5 * Math.sin(t * 0.0018 + st.p));
      ctx.fillStyle = "#cfe4f5"; ctx.beginPath(); ctx.arc(st.x, st.y, st.r, 0, 6.29); ctx.fill();
    }
    ctx.globalAlpha = 1;
    // harbour lettering sitting on the water
    var fs = Math.min(H * 0.62, W * 0.14);
    ctx.font = "700 " + fs + 'px "Barlow Condensed", "Arial Narrow", sans-serif';
    ctx.textAlign = "center"; ctx.textBaseline = "alphabetic";
    ctx.lineWidth = 1.4; ctx.strokeStyle = "rgba(143,191,228,0.22)";
    ctx.strokeText("DESIGN DOCK", W / 2, rest + fs * 0.12);
    // far swell
    seaPath(t, 14, 4, 1.7);
    ctx.fillStyle = "rgba(40,104,160,0.45)"; ctx.fill();
    // smoke
    for (var j = 0; j < puffs.length; j++) {
      var p = puffs[j], rg = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
      rg.addColorStop(0, "rgba(232,241,249," + (Math.max(0, p.life) * 0.42).toFixed(3) + ")"); rg.addColorStop(1, "rgba(232,241,249,0)");
      ctx.fillStyle = rg; ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.29); ctx.fill();
    }
    ctx.globalAlpha = 1;
    ship();
    // near sea (drawn over the hull so it sits in the water)
    seaPath(t, 0);
    var g = ctx.createLinearGradient(0, rest - 20, 0, H);
    g.addColorStop(0, "rgba(72,144,192,0.86)"); g.addColorStop(1, "rgba(23,67,107,1)");
    ctx.fillStyle = g; ctx.fill();
    ctx.beginPath();
    for (var x = 0; x <= W + SP; x += SP) { var y = surf(x, t); if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y); }
    ctx.strokeStyle = "rgba(255,255,255,0.45)"; ctx.lineWidth = 1.6; ctx.stroke();
    // spray
    ctx.fillStyle = "rgba(225,240,252,0.9)";
    for (var d = 0; d < drops.length; d++) { ctx.beginPath(); ctx.arc(drops[d].x, drops[d].y, drops[d].r, 0, 6.29); ctx.fill(); }
  }

  var running = false, raf = 0;
  function frame(t) {
    now = t; water(); sail(t); particles(); draw(t);
    raf = running ? requestAnimationFrame(frame) : 0;
  }
  function start() { if (running || reduce) return; running = true; raf = requestAnimationFrame(frame); }
  function stop() { running = false; }

  // input
  var local = function (e) { var r = cv.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
  var dismiss = function () { if (played) return; played = true; if (hint) hint.classList.add("is-gone"); };
  host.addEventListener("pointerenter", function () { ptr.in = true; });
  host.addEventListener("pointerleave", function () { ptr.in = false; });
  host.addEventListener("pointermove", function (e) {
    var p = local(e); ptr.lx = ptr.x; ptr.ly = ptr.y; ptr.x = p.x; ptr.y = p.y; ptr.t = now; ptr.in = true;
    var sy = surf(p.x, now), sp = Math.abs(ptr.x - ptr.lx);
    if (Math.abs(p.y - sy) < 16 && sp > 2) push(p.x, Math.min(6, sp * 0.25), false);
  });
  host.addEventListener("pointerdown", function (e) {
    var p = local(e); dismiss(); ptr.x = p.x; ptr.t = now; ptr.in = true;
    var onBoat = Math.abs(p.x - boat.x) < BW * 0.55 && p.y > boat.y - BW * 0.55 && p.y < boat.y + BW * 0.25;
    if (onBoat && !boat.hv) { boat.hop = -0.1; boat.hv = -7.5; }
    else if (p.y > surf(p.x, now) - 30) push(p.x, 18, true);
    if (reduce) draw(now);
  });

  size();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { draw(now); });
  window.addEventListener("resize", function () { size(); if (!running) draw(now); }, { passive: true });
  draw(0);
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (en) { if (en[0].isIntersecting) start(); else stop(); }, { rootMargin: "120px 0px" }).observe(host);
  } else start();
  document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); });
})();
